import React from "react";
import { FaJava } from "react-icons/fa";
import { FiExternalLink } from "react-icons/fi";
import {
  SiBlender,
  SiDocker,
  SiFirebase,
  SiJavascript,
  SiReact,
  SiSupabase,
  SiTailwindcss,
  SiThreedotjs,
  SiTypescript,
} from "react-icons/si";
import "../style/projectCard.css";

const technologyIcons = {
  react: { Icon: SiReact, className: "technology-icon-react" },
  typescript: { Icon: SiTypescript, className: "technology-icon-typescript" },
  "three.js": { Icon: SiThreedotjs, className: "technology-icon-threejs" },
  blender: { Icon: SiBlender, className: "technology-icon-blender" },
  "firebase firestore": {
    Icon: SiFirebase,
    className: "technology-icon-firebase",
  },
  javascript: {
    Icon: SiJavascript,
    className: "technology-icon-javascript",
  },
  "tailwind css": {
    Icon: SiTailwindcss,
    className: "technology-icon-tailwind",
  },
  supabase: {
    Icon: SiSupabase,
    className: "technology-icon-supabase",
  },
  java: { Icon: FaJava, className: "technology-icon-java" },
  dockerfile: { Icon: SiDocker, className: "technology-icon-docker" },
};

function FigmaIcon() {
  return (
    <span className="technology-figma-icon" aria-hidden="true">
      <span className="technology-figma-shape technology-figma-red" />
      <span className="technology-figma-shape technology-figma-orange" />
      <span className="technology-figma-shape technology-figma-purple" />
      <span className="technology-figma-shape technology-figma-blue" />
      <span className="technology-figma-shape technology-figma-green" />
    </span>
  );
}

const ProjectCard = ({
  image,
  title,
  languages,
  description,
  link,
  layout = "image-left",
  isExpanded,
  onToggle,
}) => {
  const technologies = languages.split(/\s*(?:,|and)\s*/i).filter(Boolean);

  return (
    <div className={`project-card ${layout}`}>
      <img src={image} alt={title} className="project-image" />
      <div className="project-content">
        <h2 className="project-title">{title}</h2>
        <div className="project-languages">
          <span className="project-languages-label">
            {technologies.length === 1 ? "Technology:" : "Technologies:"}
          </span>
          <span className="project-technology-list">
            {technologies.map((technology) => {
              const normalizedTechnology = technology.toLowerCase();
              const iconDetails = technologyIcons[normalizedTechnology];

              return (
                <span className="project-technology" key={technology}>
                  {normalizedTechnology === "figma" && <FigmaIcon />}
                  {iconDetails && (
                    <iconDetails.Icon
                      className={`project-technology-icon ${iconDetails.className}`}
                      aria-hidden="true"
                    />
                  )}
                  <span>{technology}</span>
                </span>
              );
            })}
          </span>
        </div>
        {/* 🔹 Truncate text to 3 lines with ellipsis, expand on click */}

        <p
          className={`project-description ${
            isExpanded ? "expanded" : "collapsed"
          }`}
          onClick={onToggle}
        >
          {description}
        </p>

        <a
          href={link}
          className="project-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FiExternalLink className="project-link-icon" aria-hidden="true" />
          <p className="project-link-text">View project</p>
        </a>
      </div>
    </div>
  );
};

export default ProjectCard;
